/* ---------- Intro (centered, matches getcracked.io) ---------- */

.intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  margin: 0 auto var(--space-8);
  max-width: 720px;
  text-align: center;
}

.heading {
  font-size: clamp(1.5rem, 3vw, 2.25rem);
  line-height: 1.1;
  letter-spacing: -0.025em;
  font-weight: 600;
}

.lede {
  font-size: 1.05rem;
  color: var(--text-muted);
  max-width: 56ch;
}

/* ---------- List ---------- */

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  max-width: 880px;
  margin: 0 auto;
}

.item {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: border-color var(--dur-base) var(--ease-out),
    background var(--dur-base) var(--ease-out),
    box-shadow var(--dur-base) var(--ease-out);
}

.item:hover {
  border-color: var(--border-strong);
}

.item[data-open='true'] {
  background: color-mix(in srgb, var(--surface) 70%, var(--bg-elevated));
  border-color: var(--border-strong);
  box-shadow: var(--shadow-md);
}

/* ---------- Trigger row ---------- */

.itemHeading {
  margin: 0;
}

.trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-5);
  padding: clamp(18px, 2.2vw, 22px) clamp(20px, 2.8vw, 28px);
  background: transparent;
  border: 0;
  color: var(--text);
  font-family: inherit;
  font-size: clamp(15px, 1.4vw, 16.5px);
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.4;
  text-align: left;
  cursor: pointer;
  transition: color var(--dur-base) var(--ease-out);
}

.trigger:focus-visible {
  outline: none;
  box-shadow: var(--ring);
  border-radius: var(--radius-lg);
}

.question {
  flex: 1 1 auto;
  min-width: 0;
}

/* ---------- Toggle icon (plus ⇄ X) ---------- */

.icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  color: var(--text-subtle);
  flex-shrink: 0;
  transition: color var(--dur-base) var(--ease-out);
}

.item:hover .icon {
  color: var(--text-muted);
}

.item[data-open='true'] .icon {
  color: var(--text);
}

.iconPlus,
.iconClose {
  position: absolute;
  inset: 0;
  margin: auto;
  transition: opacity var(--dur-base) var(--ease-out),
    transform var(--dur-base) var(--ease-out);
}

.iconClose {
  opacity: 0;
  transform: rotate(-45deg);
}

.item[data-open='true'] .iconPlus {
  opacity: 0;
  transform: rotate(45deg);
}

.item[data-open='true'] .iconClose {
  opacity: 1;
  transform: rotate(0);
}

/* ---------- Panel (smooth slide open/closed) ---------- */

.panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows var(--dur-slow) var(--ease-out);
}

.panel[data-open='true'] {
  grid-template-rows: 1fr;
}

.panelInner {
  min-height: 0;
  overflow: hidden;
  padding: 0 clamp(20px, 2.8vw, 28px);
  color: var(--text-muted);
  font-size: 15px;
  line-height: 1.7;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  border-top: 1px solid transparent;
  transition: padding var(--dur-slow) var(--ease-out),
    border-top-color var(--dur-slow) var(--ease-out);
}

.panel[data-open='true'] .panelInner {
  padding: clamp(18px, 2.4vw, 26px) clamp(20px, 2.8vw, 28px)
    clamp(22px, 2.8vw, 28px);
  border-top-color: var(--border);
}

.panelInner p {
  margin: 0;
  color: var(--text-muted);
}

.panelInner strong {
  color: var(--text);
  font-weight: 600;
}

/* ---------- Blockquote accent ---------- */

.quote {
  position: relative;
  margin: var(--space-2) 0;
  padding: 4px 0 4px 16px;
  border-left: 2px solid var(--accent);
  color: var(--text);
  font-style: italic;
  font-size: 14.5px;
  line-height: 1.6;
}

@media (max-width: 640px) {
  .trigger {
    gap: var(--space-4);
  }
}
